<div class="checkbox-inline">
  <!-- TODO: Add dynamic form control name -->
  <mat-checkbox [checked]="selected" (change)="this.checkChange($event)"></mat-checkbox>
  <div class="checkbox-inline__label">
    {{label}}
  </div>
</div>
